<ppt-actions-toolbar
  [reportData]="reportData()"
  [currentView]="currentView()"
  [recordsCount]="totalProperties.length"
  (navRecordNum)="navRecordNum($event)"
  [requiresSelectTempElement]="false"
></ppt-actions-toolbar>

<div class="container">
  <div class="col"></div>
  <div class="navbar">
    <ul class="navigation-list">
      <li class="navigation-item">
        @if (property.header?.propertyName) {
          <strong>{{
            property.header.propertyName + ', ' + property.header.propertyAddress
          }}</strong>
        }
      </li>
    </ul>
  </div>

  <div class="sidebar">
    <rep-development-pipeline-view-image
      [propertyImages]="property.images"
      [property]="property"
      [reportId]="reportData().reportId"
      >
    </rep-development-pipeline-view-image>
    <div class="map">
      <ng-container
        [ngTemplateOutlet]="templateProjectionMap() | selectTemplateOutlet: 'miq-summary-map'"
        [ngTemplateOutletContext]="{
          content: showMap,
          summaryAddressPaths: summaryAddressPaths,
          isGroupByProperty: false,
          recordList: record,
          reportIcon: 'reportSingleIcon',
        }"
      ></ng-container>
    </div>
    <ng-template #showMap> </ng-template>
  </div>
  <div class="main-content">
    <div class="accommodation-financialterms">
      <div class="accommodation">
        <h3 class="property-title">{{ 'template.accommodation' | translate }}</h3>
        <div>
          <mat-table [dataSource]="property.accommodations.floors || []" class="accommodation-table">
            <ng-container matColumnDef="FLOOR">
              <mat-header-cell *matHeaderCellDef>{{ 'template.floor' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.floor }} </mat-cell>
              <mat-footer-cell *matFooterCellDef class="footer">{{ 'template.total' | translate }}</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="SQM">
              <mat-header-cell *matHeaderCellDef>{{ 'template.sqm' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.sqm }} </mat-cell>
              <mat-footer-cell *matFooterCellDef class="footer">
                {{ property.accommodations.totalSqm }}
              </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="SQFT">
              <mat-header-cell *matHeaderCellDef>{{ 'template.sqft' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.sqft }} </mat-cell>
              <mat-footer-cell *matFooterCellDef class="footer">
                {{ property.accommodations.totalSqft }}</mat-footer-cell
                >
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
              <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
            </mat-table>
          </div>
        </div>
        <div class="financialterms">
          <h3 class="property-title">{{ 'template.financialTerms' | translate }}</h3>
          @if (property.financialTerms) {
            <div>
              <mat-table [dataSource]="financialTermsData" class="finance-table">
                <ng-container matColumnDef="occupancyCost">
                  <mat-header-cell *matHeaderCellDef>{{ 'template.occupancyCosts' | translate }}</mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.key | translate }}</mat-cell>
                  <mat-footer-cell *matFooterCellDef class="footer">{{ 'template.total' | translate }}</mat-footer-cell>
                </ng-container>
                <ng-container matColumnDef="perSqft">
                  <mat-header-cell *matHeaderCellDef class="align-right">{{ 'template.perSqft' | translate }}</mat-header-cell>
                  <mat-cell *matCellDef="let element" class="align-right"> {{ element.value }} </mat-cell>
                  <mat-footer-cell *matFooterCellDef class="align-right footer">
                    {{ property.financialTerms.total }}
                  </mat-footer-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="financialTermColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: financialTermColumns"></mat-row>
                <mat-footer-row *matFooterRowDef="financialTermColumns"></mat-footer-row>
              </mat-table>
            </div>
          }
        </div>
      </div>

      <h3 class="property-title">{{ 'template.specificationAndAminities' | translate }}</h3>

      @if (property.amenities) {
        <div>
          <ul class="navigation-list">
            @for (status of property?.amenities; track status) {
              <li class="list-item">{{ status }}</li>
            }
          </ul>
        </div>
      }

      <h3 class="property-title">{{ 'template.statusAndCondition' | translate }}</h3>

      @if (statusAndCond) {
        <div>
          <ul class="navigation-list">
            @if (statusAndCond?.status) {
              <li class="list-item">{{ statusAndCond.status }}</li>
            }
            @if (statusAndCond?.qualityType) {
              <li class="list-item">{{ statusAndCond.qualityType }}</li>
            }
            @if (statusAndCond?.readyToOccupy) {
              <li class="list-item">
                {{ ('template.readyToOccupy' | translate) + ' ' + statusAndCond.readyToOccupy }}
              </li>
            }
          </ul>
        </div>
      }
      <h3 class="property-title">{{ 'template.leasingPolicy' | translate }}</h3>
      <div>
        <ul class="navigation-list">
          @if (property.leasingPolicy) {
            <li class="list-item">{{ property.leasingPolicy }}</li>
          }
        </ul>
      </div>
    </div>
  </div>
